import { FiltersCountNameEnum } from '../shared/types';

export type Props = {
  filtersCounts: Record<string, any>;
  nameEnum: FiltersCountNameEnum;
};

/**
 * Basically flattens the facets array to key: docCount
 */
export const getCountsPerFilterName = ({ filtersCounts, nameEnum }: Props) => {
  return filtersCounts?.[nameEnum]?.reduce((acc, item) => {
    acc[item.key] = item.docCount ?? 0;

    return acc;
  }, {});
};
